var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00272D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.2,11 44.8,10.9 5.2,10.9 5,10.9 25,28.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.4,12.8L33.2,25.3l14.1,12.3c0.2-0.4,0.4-0.8,0.4-1.3V13.7C47.6,13.4,47.5,13.1,47.4,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.6,12.6c-0.1,0.3-0.2,0.7-0.2,1.1v22.6c0,0.4,0.1,0.8,0.3,1.2l14.2-12.2L2.6,12.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25,32.5 19,27.2 5.1,39.1 5.2,39.1 44.6,39.1 31,27.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b1e9d2853ac9d44f7a6b4b6d730ab24f.svg";
export { ForwardRef as ReactComponent };